import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import File from "@/models/File/File";
import {mutateDateTimeWithoutSeconds} from "@/utils/mutators";
import Receiver from "@/models/User/Notification/Receiver/Receiver";

export default class Notification extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user/notification';

    /**
     *
     * @type {string}
     */
    static entity = 'userNotifications';

    static fields() {
        return {
            id: this.number(null).nullable(),
            title: this.attr(null),
            message: this.attr(null),
            scheduled_at: this.attr(null),
            send_until: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            file_id: this.number(null).nullable(),
            image_url: this.attr(null).nullable(),
            receivers: this.hasMany(Receiver, 'user_id'),
            user: this.belongsTo(User, 'user_id'),
            file: this.belongsTo(File, 'file_id','id'),
        }
    }

    static mutators () {
        return {
            scheduled_at: mutateDateTimeWithoutSeconds,
            send_until: mutateDateTimeWithoutSeconds,
        }
    }

    static updateReceived(notificationId, userId){
        return this.api().action(notificationId + '/received-by/' + userId).update();
    }
}
